<template>
  <div>
    <!-- <v-card-title class="text-center">
              {{$t("SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS (HIES/BA)")}} <br>
              {{$t("2024/2025")}}
              
    </v-card-title> -->
    <v-row>
      <v-carousel
        height="600"
        show-arrows="hover"
        cycle
        hide-delimiter-background
        style=" margin-top: 180px;"
        class="rounded-xl"

      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
        >
          <v-card
            :color="colors[i]"
            height="100%"
            class="justify-center"
          >
          <div class="d-flex fill-height justify-center align-center">
            <img :src="slide" style="width: 50%; height: 100%;" alt="Slide Image">
          </div>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-row>

    <v-row>
      <v-col>
          <v-card
            class="mx-auto rounded-xl"
            max-width="100%"
            :elevation="10"
          >
            <v-card-title class="text-center">
              {{$t("SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS (HIES/BA)")}} <br>
              {{$t("2024/2025")}} <br>
              
            </v-card-title>
            
            <v-card-actions>
              
              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show = !show"
              >
                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show">
                <v-divider></v-divider>

                <v-card-text>
                  {{$t("Jabatan Perangkaan Malaysia melaksanakan Survei Pendapatan, Perbelanjaan Isi Rumah dan Kemudahan Asas bagi tahun 2024/2025. Tujuan utama ialah untuk mengumpul maklumat bagi analisis perangkaan.")}}
                  <br><br> 
                  <!-- The Department of Statistics, Malaysia is conducting the Household Income, Expenditure and Basic Amenities Survey for year 2024/2025. The main objective is to collect information for statistical analysis. -->
                  <br><br> 
                  {{$t("Maklumat yang dikumpul mengikut peruntukan di bawah Akta Perangkaan, 1965 (Disemak – 1989). Seksyen 5 di bawah Akta ini menghendaki mana-mana responden di Malaysia untuk memberikan maklumat sebenar atau anggaran terbaik kepada Jabatan. Mengikut Akta ini, kandungan soal selidik yang diterima adalah SULIT dan tidak boleh dihebahkan kepada sesiapa atau mana-mana institusi di luar Jabatan ini. Sementara itu, Seksyen 7 di bawah Akta yang sama memperuntukkan denda kepada responden yang gagal memberi kerjasama kepada survei yang dijalankan.")}}
                  <br><br>
                  <!-- The information is gathered under the provisions of the Statistics Act, 1965 (Revised – 1989). Section 5 of this Act requires respondent in Malaysia to provide actual information or best estimates  to the Department. The Act stipulates that the contents of the individual return are CONFIDENTIAL and will not be divulged to any person or institution outside this Department. Meanwhile, Section 7 under the same Act provides the penalty to the respondent that could not comply to the survey undertaken. -->
                  <br><br>
                  {{$t("Penyertaan anda adalah penting dalam memastikan maklumat yang dikumpul dalam soal selidik ini adalah tepat.")}}
                  <br><br>
                  <!-- Your participation is vital in ensuring that the information collected in this questionnaire is accurate. -->
                  <br><br>
                  {{$t("Kerjasama anda dalam menjayakan survei ini amat dihargai.")}}
                  <br><br>
                  <!-- Your co-operation in ensuring the success of this survey is very much appreciated. -->
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
      </v-col>

      <v-col>
          <v-card class="rounded-xl" :elevation="10">
            <v-card-title> Carian pantas </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <strong>Sila Masukkan Nombor HID</strong>
                  <v-text-field
                      v-model="nomborHID"
                      outlined
                      dense
                      :error-messages="hidErrors"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <strong>Sila Masukkan Tahun Kutipan</strong>
                  <v-text-field
                      v-model="tahunKutipan"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>
                  <v-btn
                      color="success"
                      rounded
                      @click="goTo()"
                      :disabled="butangTeruskan"
                      >
                      {{$t("TERUSKAN")}}
                  </v-btn>
            </v-card-text>

              
          </v-card>
      </v-col>
    </v-row>
    <!-- power bi -->
    

  </div>
</template>

<script>
// @ is an alias to /src
import { ParticlesBg } from "particles-bg-vue";

import PieChart from '@/components/PieChart'

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();


export default {

  // components: {
  //   PieChart
  // },
  // components: {
  //   ParticlesBg
  // },
  beforeMount(){
    this.userData = localStorageData.user();
    this.currentUser = this.userData.name.toUpperCase();
    
  },
  data: () => ({
    nomborHID:'',
    tahunKutipan:'',
    butangTeruskan: true,
    userData : '',
    publicHIDdata:'',
    show: false,
    hidErrors:[],
    rules: {
         required: v => !!v || 'field is required',
         HIDLength: (value) => {
            return (value && value.length == 26) || 'must be 26 digit'
          },
        },
     colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        // slides: [
        //   'First',
        //   'Second',
        //   'Third',
        //   'Fourth',
        //   'Fifth',
        // ],
        slides: [
          require('@/assets/corousell/4.jpeg'), 
          require('@/assets/corousell/1.jpg'), // Update with the path to your image assets
          require('@/assets/corousell/2.jpg'), 
          require('@/assets/corousell/3.jpg'), 

          
          // Add more paths to your images if needed
        ],

        // embedUrl: {
        //   type: String,
        //   required: true
        // }
        embedUrl: "https://app.powerbi.com/view?r=eyJrIjoiNWRiNjMyODgtMGY2OS00OTFiLTliNGEtYzY3MmU0M2IxZDZkIiwidCI6IjM3M2U5MGQyLWQ5YTMtNDNiNS04MzJlLWM4ZTk4NDdhNzlmOCIsImMiOjEwfQ%3D%3D"
  }),
  methods:{
    async goTo(){
        this.hidErrors = [];
        var res = await publicServices.getBorangByHID(this.nomborHID, this.tahunKutipan);//dapatkan data HID

        if(!res.data.status){
          this.hidErrors = ["HID tidak wujud atau pengemaskinian tidak dibenarkan"];
        }else{
          this.publicHIDdata = res.data.data[0];
          var setHIDtoLocalStorage = localStorageData.setHID(this.publicHIDdata);//setkan data HID ke dalam local storage
          this.$router.push({name: "ringkasanMaklumatIR"});
        }
        
    },
  },
  watch:{
    nomborHID(val){
      if(val.length < 1 && this.tahunKutipan == ''){
        this.butangTeruskan = true;
      }else{  
        this.butangTeruskan = false;
      }
    }
  }
}
</script>

<!-- <style>
#app{
  /* background: url('https://chatbot.dosm.gov.my/admin/files/dosm/images/chatbot/chatbotlogo.jpg') */
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}
</style> -->

